import { SnackbarData } from "../../../core/models/snackbar/snackbar.model";

const initialSnackbarData: SnackbarData = {
  isOpen: false,
  isSuccessSeverity: false,
  text: "",
};

export { initialSnackbarData };
